import { ReactComponent as ThreeDotsVertical } from 'assets/img/icons/v2/three-dots-vertical.svg';
import Session from "components/LM/Auth/Session";
import ModalDisplay from "components/LM/common/ModalDisplay";
import K2Api from 'lib/ajax/K2Api';
import { useState } from "react";
import { Trash2 } from 'react-feather';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { Loader, ToastService, Tooltip } from "@launchmetrics/lm-ui";
import 'components/LM/Voice/VoiceDropdownButton.scss';

function countSources(voice) {
	const countGrouped = (grouped) =>
		Object.values(grouped ?? {}).reduce((total, items) => total + (items?.length ?? 0), 0);

	return countGrouped(voice.socialmedia) + countGrouped(voice.medias) + (voice.urls?.length ?? 0);
}

function VoiceDropdownButton(props) {
    const { voice } = props;
	const session = new Session();

	const hasSources = countSources(voice) > 0;

	const [showDeleteModal, setShowDeleteModalState] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const showLoader = () => {
		if (loading) {
			return <Loader styleProps={{ marginLeft: '10px'}}size={20} />;
		}
	}
	const deleteButtonText = (<><Trash2 size="13" /> Remove Voice {showLoader()}</>);

	const triggerDelete = async () => {
		setLoading(true);
		try {
			const k2Api = new K2Api();
			const response = await k2Api.delete(`/voices/${voice.id}`);
			if (response) {
				setShowDeleteModalState(!showDeleteModal);
				const currentUrl = new URL(window.location.href);
				window.location.href = currentUrl.origin + '/voices/search';
			}
		} catch (err) {
			ToastService.show({
				id: "delete-voice-failed",
				title: "Failed to delete voice",
				type: "error"
			});
		}
	}

	return (
		<>
			<Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} className="ml-2 d-inline-block">
				<DropdownToggle color="outline-dark" size="sm" className="custom-gray-border custom-dropdown-toggle">
					<ThreeDotsVertical height="12" />
				</DropdownToggle>
				<DropdownMenu end className="mt-2">
					<DropdownItem href={`/voices/logs/${voice.id}`}>View Audit Logs</DropdownItem>
					<DropdownItem divider />
					{hasSources ? (
						<Tooltip content="This voice has sources and cannot be deleted." placement="left">
							<span className="d-inline-block w-100">
								<DropdownItem toggle={false} disabled style={{ pointerEvents: "none" }}>Delete Voice</DropdownItem>
							</span>
						</Tooltip>
					) : (
						<DropdownItem onClick={() => { setShowDeleteModalState(!showDeleteModal) }} disabled={!session.hasPermission("edit")}>Delete Voice</DropdownItem>
					)}
				</DropdownMenu>
			</Dropdown>
			<ModalDisplay
				isVisible={showDeleteModal}
				headerText={`Are you sure you want to delete ${voice.name}?`}
				contentText={"Are you sure you want to delete the following voice?"}
				color="danger"
				confirmButtonText={deleteButtonText}
				onCancel={() => setShowDeleteModalState(!showDeleteModal)}
				onConfirm={() => triggerDelete()}
			/>
		</>
	);
}

export default VoiceDropdownButton;
